export const toBase64 = ({ file, removeMetadata }: { file: File; removeMetadata?: boolean }) =>
  new Promise<string | undefined>((resolve, reject) => {
    const reader = new FileReader()

    reader.readAsDataURL(file)
    reader.onload = () => {
      let result = reader.result?.toString()

      if (removeMetadata) {
        result = result?.replace(/^.+(;base64),/, '')
      }

      resolve(result)
    }
    reader.onerror = error => reject(error)
  })
